module.exports = __webpack_public_path__ + "87d8b1ed41e5ef1780c5a8d599f5cefd.png";